import { BillableStateType } from './model';
export function makeBillable() {
    let maxCharges = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return {
        type: BillableStateType.Billable,
        billable: {
            chargesLeft: maxCharges
        }
    };
}
export function makeNonBillable(reason) {
    return {
        type: BillableStateType.NonBillable,
        nonBillable: {
            reason
        }
    };
}
